import { RelationshipComments } from "../../components/comments/RelationshipComments";
import { useRelationshipCommentCreate } from "../../hooks/api/v2/relationshipComments/useRelationshipCommentCreate";
import { useRelationshipCommentList } from "../../hooks/api/v2/relationshipComments/useRelationshipCommentList";

export const MessageThread = ({
  relationshipId,
  flaggedAsBadPayer,
  className,
}: {
  relationshipId: number;
  flaggedAsBadPayer?: boolean;
  className?: string;
}) => {
  const relationshipCommentQuery = useRelationshipCommentList({
    limit: 10,
    sortBy: "createdAt",
    sortDir: "desc",
    query: [
      {
        type: "RelationshipId",
        modifier: "EQUALS",
        value: relationshipId,
      },
    ],
  });

  const mutation = useRelationshipCommentCreate();

  return (
    <RelationshipComments
      relationshipId={relationshipId}
      mutation={mutation}
      commentsQuery={relationshipCommentQuery}
      className={className}
      flaggedAsBadPayer={flaggedAsBadPayer}
    />
  );
};
